import { render, staticRenderFns } from "./ApexBaseChart.vue?vue&type=template&id=45b832d0"
import script from "./ApexBaseChart.vue?vue&type=script&lang=js"
export * from "./ApexBaseChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports